// extracted by mini-css-extract-plugin
module.exports = {"statsItem":"statsItem_statsItem__Hw9fI","statsItem__value":"statsItem_statsItem__value__OfTKL","statsItem__text":"statsItem_statsItem__text__aCcle"};